module.exports = __webpack_public_path__ + "img/learning-forest_strategy_and_information_architecture.8cdff183.jpg";